import React, { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./Services.css";
// Import full service data from carousel, no duplicate code
import { serviceData } from "../components/ServicesCarousel";

const Services = () => {
  const [searchParams] = useSearchParams();
  const selectedServiceFromUrl = searchParams.get("selected");
  const contentRef = useRef(null);

  // Auto select service if coming from carousel click
  const getDefaultActive = () => {
    if(selectedServiceFromUrl) {
      const found = serviceData.find(item => item.title === decodeURIComponent(selectedServiceFromUrl));
      if(found) return found;
    }
    return serviceData[0];
  }

  const [active, setActive] = useState(getDefaultActive);

  const handleServiceClick = (item) => {
    setActive(item);
    if (window.innerWidth <= 900) {
      setTimeout(() => {
        contentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  };

  // Auto scroll to content when opening service from carousel on mobile
  useEffect(() => {
    if(selectedServiceFromUrl && window.innerWidth <= 900) {
      setTimeout(() => {
        contentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
      }, 150)
    }
  }, [selectedServiceFromUrl])

  return (
    <div className="service-page">
      <h1 className="service-title">Our Premium Services</h1>

      <div className="service-layout">
        <aside className="service-sidebar">
          {/* ALL 14 services are visible here exactly as you had in your old code */}
          {serviceData.map((item, index) => (
            <div
              key={index}
              className={`service-item 
              ${active.title === item.title ? "active" : ""}
              ${item.bestSeller ? "best-seller" : ""}`}
              onClick={() => handleServiceClick(item)}
            >
              <span>{item.title}</span>
              <div className="item-right">
                {item.bestSeller && <span className="badge">Best Seller</span>}
                <span className="arrow">›</span>
              </div>
            </div>
          ))}

          <div className="service-book">
            Book Your Event
            <strong>+91 90877 75659</strong>
          </div>
        </aside>

        <section ref={contentRef} className="service-content">
          <img src={active.image} alt={active.title} loading="lazy" />
          <h2>
            {active.title}
            {active.bestSeller && <span className="content-badge">Best Seller</span>}
          </h2>
          <p>{active.description}</p>
          <a href="/" className="service-book-btn">
            Book Your Celebration
          </a>
        </section>
      </div>
    </div>
  );
};

export default Services;